import { Type } from 'class-transformer';
import { BaseEntity } from '@models';
import { Organization } from '@services/organization';
import { Role } from '@services/role/role.class';
import { UserInvitationState } from './user-invitation-state.enum';

export class UserInvitation extends BaseEntity {
	email: string;
	name: string;
	surname: string;

	state: UserInvitationState;

	@Type(() => Organization)
	organization: Organization;

	@Type(() => Role)
	role: Role;

	roleId: number;

	@Type(() => Date)
	userActionAt?: Date;
}
